export default __webpack_public_path__ + "static/media/ISMO SYLLABUS_2026-27 CLASS 2.bcf71cc3.pdf";